/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify';
import query from './query';
import i18n from '../i18n';
import pinia from '../store';
import router from '../router';

export async function registerPlugins(app) {
  app
    .use(vuetify)
    .use(query)
    .use(i18n)
    .use(pinia)
    .use(router);
}
